import { postToAuthEndpoint } from '../config/axiosConfig';
import { assertApiSuccess, extractPayload } from '../utils/apiResponseUtils';

export const signupOtp = async (action, { role = 'DRIVER', ...data }) => {
  const response = await postToAuthEndpoint('/auth/' + (action === 'send' ? 'send-otp' : 'verify-otp'), { ...data, purpose: 'SIGNUP', role });
  assertApiSuccess(response, { delivery: action === 'send' });
  const payload = extractPayload(response.data) || {};
  const field = action === 'send' ? 'requestToken' : 'verificationProofToken';
  if (typeof payload[field] !== 'string' || !payload[field].trim()) throw new Error('The server did not return ' + field + '. Please request a new code.');
  if (action !== 'send' && (payload.verified === false || payload.isVerified === false)) throw new Error('Verification was not confirmed. Please retry the OTP.');
  return payload;
};
